import { PageLayout } from '@/components/page-layout';
import { MAX_PAGE_WIDTH } from '@/constants/shared';
import { Box, VStack } from '@chakra-ui/react';
import { LifiWidget } from './LifiWidget';
import { OtherBridgeInfo } from './OtherBridgeInfo';
import { PlumeAssetsInfo } from './PlumeAssetsInfo';

export const Bridge = () => {
  return (
    <PageLayout>
      <Box position="relative" w="full">
        {/* Background image behind content */}
        <Box
          position="absolute"
          top={-14}
          left="50%"
          transform="translateX(-50%)"
          w={['calc(100% + 16px)', 'calc(100% + 16px)', 'calc(100% + 48px)']}
          h={['300px', '459px']}
          bgImage="url('/assets/bridge/bridge-hero.avif')"
          bgRepeat="no-repeat"
          bgPos="center"
          bgSize="cover"
          borderBottomRadius="24px"
          zIndex={0}
        />

        {/* Reserve vertical space for the hero (keeps content in normal flow) */}
        <Box h={16} />

        {/* Foreground content */}
        <Box position="relative" zIndex={1}>
          {/* Overlap the widget slightly into the hero if desired */}

          <LifiWidget />

          <VStack gap={[6, 6, 16]} w="full" maxW={MAX_PAGE_WIDTH} mx="auto" mt={20}>
            <PlumeAssetsInfo />
            <OtherBridgeInfo />
          </VStack>
        </Box>
      </Box>
    </PageLayout>
  );
};
